/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-timed-button',
  templateUrl: './timed-button.component.html',
  styleUrls: ['./timed-button.component.scss'],
  standalone: false
})
export class TimedButtonComponent implements OnInit, OnDestroy {
  /**
   * azione da eseguire
   */
  @Input() action: () => void;

  /**
   * durata in secondi del tempo di attesa per richiedere nuovamente l'azione
   */
  @Input() waitDuration = 30;

  /**
   * numero di tentativi massimi
   */
  @Input() maxAttemps = Infinity;

  /**
   * testo da mostrare quando il countdown è in corso
   */
  @Input() waitingText = '';

  /**
   * testo da mostrare quando la richiesta è sbloccata
   */
  @Input() readyText = '';

  /**
   * disabilita il buttone
   */
  @Input() disabled: boolean;

  /**
   * flag per determinare l'inizializzazione del count down
   */
  @Input() initialCountdown: boolean;

  /**
   * tempo rimanente per sbloccare bottone
   */
  remainingTime: number;

  /**
   * numero di tentativi eseguiti
   */
  attemps: number;

  /**
   * interval
   */
  private interval: any;

  constructor() {}

  ngOnInit() {
    this.attemps = 0;
    this.beginCountdown();
  }

  ngOnDestroy() {
    this.cleanCountdown();
  }

  /**
   * richiede l'azione
   */
  requireAction(): void {
    if (typeof this.action !== 'function') {
      return;
    }

    this.attemps++;

    if (this.attemps > this.maxAttemps) {
      return;
    }

    this.action();
    this.startCountdown();
  }

  /**
   * fa partire inizialmente il count down
   */
  private beginCountdown(): void {
    if (!this.initialCountdown) {
      return;
    }

    this.startCountdown();
  }

  /**
   * avvia countdown
   */
  private startCountdown(): void {
    this.cleanCountdown();

    this.remainingTime = this.waitDuration;

    this.interval = setInterval(() => {
      this.updateRemainingTime();
    }, 1000);
  }

  /**
   * aggiorna il tempo rimanente
   */
  private updateRemainingTime(): void {
    if (this.disabled) {
      return;
    }

    if (this.remainingTime <= 0) {
      return this.cleanCountdown();
    }

    this.remainingTime--;
  }

  /**
   * pulisce countdown
   */
  private cleanCountdown(): void {
    clearInterval(this.interval);
    this.interval = undefined;
  }
}
